export default class OffrePropositionRemiseModalController {
	static $inject = ['$state', '$stateParams', 'notification', '$translate'];

	constructor($state, $stateParams, notification, $translate) {
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.notification = notification;
		this.produit = {};
		this.remiseValeur = 0;
		this.prixApplique = 0;
		this.prixOrigine = 0;
		this.remiseType = '0';
	}

	async $onInit() {
		this.produit = this.resolve.produit;
		this.prixApplique = this.produit.prixVente;
		this.remiseValeur = this.produit.remiseValeur;

		// Cast booléen pour éliminer null/undefined/0
		this.prixOrigine = this.produit.prixOrigine ?? this.produit.prixVente;

		this.remiseType = `${this.produit.remiseType}`;
		this.calculerRemise();
		console.log('PRODUIT In', this.produit);
	}

	formatValue(value) {
		if (Number.isInteger(value)) {
			return value;
		} else {
			return parseFloat(value.toFixed(2));
		}
	}

	async calculerRemise() {
		this.remiseValeur = parseFloat(this.remiseValeur);
		this.prixOrigine = parseFloat(this.prixOrigine);
		if (this.remiseType === '2') {
			this.prixApplique = this.formatValue(Number(this.prixOrigine - (this.prixOrigine * this.remiseValeur) / 100));
		} else if (this.remiseType === '1') {
			if (this.remiseValeur > this.prixOrigine) {
				this.remiseValeur = this.prixOrigine;
			}

			this.prixApplique = this.formatValue(this.prixOrigine - this.remiseValeur);
		} else {
			this.prixApplique = this.formatValue(this.remiseValeur);
		}
	}

	ok() {
		this.produit.remiseType = Number(this.remiseType);
		this.produit.prixVente = this.prixApplique;
		this.produit.remiseValeur = this.remiseValeur;
		this.produit.prixOrigine = this.prixOrigine;
		console.log('PRODUIT Out', this.produit);
		this.modalInstance.close(this.produit);
	}

	supprimerRemise() {
		this.produit.remiseType = 0;
		this.produit.remiseValeur = 0;
		this.produit.prixVente = this.produit.prixOrigine;
		this.modalInstance.close(this.produit);
	}

	close() {
		this.modalInstance.close();
	}
}
